/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const InvoiceStatus = {
    ReadyForInvoice: 'ReadyForInvoice',
    ReadyForReceipt: 'ReadyForReceipt',
    Invoiced: 'Invoiced',
    Failed: 'Failed'
} as const;
export type InvoiceStatus = typeof InvoiceStatus[keyof typeof InvoiceStatus];


export function instanceOfInvoiceStatus(value: any): boolean {
    for (const key in InvoiceStatus) {
        if (Object.prototype.hasOwnProperty.call(InvoiceStatus, key)) {
            if (InvoiceStatus[key as keyof typeof InvoiceStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function InvoiceStatusFromJSON(json: any): InvoiceStatus {
    return InvoiceStatusFromJSONTyped(json, false);
}

export function InvoiceStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoiceStatus {
    return json as InvoiceStatus;
}

export function InvoiceStatusToJSON(value?: InvoiceStatus | null): any {
    return value as any;
}

export function InvoiceStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): InvoiceStatus {
    return value as InvoiceStatus;
}

